import { createContext, useContext, useMemo, useState } from 'react'

export const TabContext = createContext({
  selectedValue: null
})

export const useTabGroup = () => {
  const tabGroupContext = useContext(TabContext)

  return tabGroupContext
}

export const useTabGroupValues = (tabOptions, _defaultValue) => {
  const { options, defaultValue } = useMemo(() => {
    const entries = Object.entries(tabOptions)
    const options = entries.map(([value, payload]) => ({
      value,
      payload
    })).sort((a, b) => a?.payload?.order - b?.payload?.order)

    const defaultValue = _defaultValue ?? options.find((val) => !val?.payload?.disabled)?.value

    return {
      options,
      defaultValue
    }
  }, [_defaultValue, tabOptions])
  const [selectedValue, setSelectedValue] = useState(defaultValue)

  return useMemo(() => ({
    selectedValue,
    selectValue: setSelectedValue,
    options
  }), [selectedValue, setSelectedValue, options])
}
